import type { ExportStatus, PipingSystem } from '../types';

export interface ExportSystemStatusSummary {
  notValidated: number;
  ready: number;
  warnings: number;
  errors: number;
}

export function resolvePipingSystemStatus(system: PipingSystem): ExportStatus {
  if ((system.errorCount || 0) > 0) {
    return 'Errors';
  }
  if ((system.warningCount || 0) > 0) {
    return 'Warnings';
  }

  const raw = String(system.status || '').trim().toLowerCase();
  if (
    raw === ''
    || raw === 'notvalidated'
    || raw === 'not validated'
    || raw === 'needs validation'
    || raw === 'validation required'
    || raw === 'not-run'
    || raw === 'not run'
    || raw === 'unvalidated'
    || raw === 'unknown'
  ) {
    return 'NotValidated';
  }
  if (raw === 'errors' || raw === 'error' || raw === 'failed' || raw === 'critical') {
    return 'Errors';
  }
  if (raw === 'warnings' || raw === 'warning') {
    return 'Warnings';
  }
  if (
    raw === 'ready'
    || raw === 'passed'
    || raw === 'pass'
    || raw === 'ok'
    || raw === 'success'
    || raw === 'valid'
  ) {
    return 'Ready';
  }
  return 'NotValidated';
}

export function markPipingSystemValidationPending(system: PipingSystem): PipingSystem {
  return {
    ...system,
    status: 'NotValidated',
    warningCount: 0,
    errorCount: 0,
    validationScopeElementIds: [],
    validationScopeSystemNames: [],
  };
}

export function summarizePipingSystems(systems: PipingSystem[]): ExportSystemStatusSummary {
  return systems.reduce<ExportSystemStatusSummary>(
    (summary, system) => {
      const status = resolvePipingSystemStatus(system);

      if (status === 'NotValidated') {
        summary.notValidated += 1;
      } else if (status === 'Errors') {
        summary.errors += 1;
      } else if (status === 'Warnings') {
        summary.warnings += 1;
      } else {
        summary.ready += 1;
      }

      return summary;
    },
    { notValidated: 0, ready: 0, warnings: 0, errors: 0 }
  );
}
